import React from 'react';

export default function NeoRecaptcha({ config, onSubmit=()=>{}, lang }) {
	const captcha_id = React.useRef(null);
	const element_id = 'recaptcha-container';
	const script_id = 'google-recaptcha';
	let { recaptcha: { site_key, theme, size }} = config;

	const onValidate = React.useCallback(token => {
		onSubmit({ data: {
			recaptcha_token: token
		}});
	}, [ onSubmit ]);

	const onLoadCallback = React.useCallback(() => {
        // We assume loading the script will take longer than setting the ref
        try{
            captcha_id.current = window.grecaptcha.render(element_id, {
			sitekey: site_key,
			theme: theme,
			size: size,
			callback: onValidate
          });
        } catch(error){
            // The component is instanciate many times in genericStep.js, and do not allow to instanciate more than one.
        }

	}, [ onValidate, site_key, theme, size ]);

    window.onLoadCallback = onLoadCallback;

	React.useLayoutEffect(() => {
		let exists = document.querySelector(`#${script_id}`);
		if(exists) {
			exists.parentElement.removeChild(exists);
		}

		let script = document.createElement('script');
		script.id = script_id;
		script.src = `https://www.google.com/recaptcha/api.js?onload=onLoadCallback&render=explicit&hl=${lang}`;

		document.head.appendChild(script);
	}, [ lang ]);

	return (
		<div className="neo-recaptcha">
			<div id={element_id}/>
		</div>
	);
}
